


















































import { Component, Vue, Inject, Provide } from 'vue-property-decorator';
import { OfferService } from '@/services/OfferService';
import { SmartphoneService } from '@/services/SmartphoneService';
import { MedicalService } from '@/services/MedicalService';

@Component({})
export default class App extends Vue {

	@Provide()
	offerService = new OfferService();

	@Provide()
	smartphoneService = new SmartphoneService();

	@Provide()
	medicalService = new MedicalService();
}
